import * as React from 'react'
import { Link } from 'react-router-dom'
import { IQuestionnaire, QuestionnaireStatus } from '../../../Model/Questionnaire'
import LocalizationStore from '../../../Stores/LocalizationStore'
import UserStore from '../../../Stores/UserStore'

export interface IPaymentScheduleEditLinkViewPeops {
    questionnaire: IQuestionnaire
}

function checkCanEdit(q: IQuestionnaire) {

    const us = UserStore.getInstance()
    return us.checkAdmin
        || us.checkSuperAdmin
        || (
            us.checkCreditExpert &&
            q.status === QuestionnaireStatus.InProgressCreditExpert &&
            q.inProgressByUserId === us.id
        )
}

export const PaymentScheduleEditLinkView = (props: IPaymentScheduleEditLinkViewPeops) => {
    return (
        <div className="col-6">
            <Link
                hidden={!checkCanEdit(props.questionnaire)}
                to={'/paymentsSchedule/' + props.questionnaire.id}
            >
                {LocalizationStore.getInstance().t('changePaymentsScheduleLink')}
            </Link>
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/PaymentSchedule/PaymentScheduleEditLinkView.tsx